import React, { useEffect, useState } from 'react';
import MainLayout from '../../layout/MainLayout';
import { api } from '../../api/axios';
import { tableDateFormate } from '../../utils/dateHelper';
import PaginationBar from '../../components/PaginationBar';
import { ShieldAlert } from 'lucide-react';

const PAGE_SIZE = 20;

export default function FailedLogins() {
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [notFound, setNotFound] = useState(false);

    const fetchItems = async (p = page) => {
        setLoading(true);
        setNotFound(false);
        try {
            const res = await api.get(`/failed-logins?page=${p}&pageSize=${PAGE_SIZE}`);
            const data = res.data || {};
            setItems(data.items || data.logs || []);
            setTotalItems(data.total ?? data.totalItems ?? 0);
            setTotalPages(data.totalPages ?? Math.ceil((data.total || 0) / PAGE_SIZE) ?? 1);
        } catch (err) {
            if (err?.response?.status === 404) {
                setNotFound(true);
                setItems([]);
            } else {
                console.error('Failed-logins fetch error:', err);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchItems(page);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    return (
        <MainLayout title="Failed Logins">
            <div className="bg-white border rounded-2xl shadow-sm overflow-x-auto">
                <table className="w-full text-left">
                    <thead className="bg-gray-50 text-gray-600 uppercase text-xs font-semibold">
                        <tr>
                            <th className="px-6 py-4">Timestamp</th>
                            <th className="px-6 py-4">Email Attempted</th>
                            <th className="px-6 py-4">IP</th>
                            <th className="px-6 py-4">User-Agent</th>
                            <th className="px-6 py-4">Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={5} className="px-6 py-10 text-center text-gray-400">Loading...</td>
                            </tr>
                        ) : notFound ? (
                            <tr>
                                <td colSpan={5} className="px-6 py-10 text-center text-gray-400">
                                    <div className="flex flex-col items-center gap-2">
                                        <ShieldAlert size={32} className="text-gray-300" />
                                        <div className="font-medium">Failed-logins API not available</div>
                                        <div className="text-xs">The server endpoint <code>GET /api/v1/failed-logins</code> is not implemented yet.</div>
                                    </div>
                                </td>
                            </tr>
                        ) : items.length === 0 ? (
                            <tr>
                                <td colSpan={5} className="px-6 py-10 text-center text-gray-400">
                                    No failed-login attempts recorded.
                                </td>
                            </tr>
                        ) : (
                            items.map((it, idx) => (
                                <tr key={it._id || idx} className="border-b hover:bg-gray-50">
                                    <td className="px-6 py-3 text-sm text-gray-700 whitespace-nowrap">
                                        {it.timestamp || it.createdAt ? tableDateFormate(it.timestamp || it.createdAt) : '-'}
                                    </td>
                                    <td className="px-6 py-3 text-sm">{it.email || it.username || '-'}</td>
                                    <td className="px-6 py-3 text-xs font-mono">{it.ip || '-'}</td>
                                    <td className="px-6 py-3 text-xs text-gray-500 truncate max-w-xs" title={it.userAgent}>
                                        {it.userAgent || '-'}
                                    </td>
                                    <td className="px-6 py-3 text-sm text-red-600">{it.reason || '-'}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="mt-4">
                <PaginationBar
                    page={page}
                    pageSize={PAGE_SIZE}
                    totalItems={totalItems}
                    totalPages={totalPages}
                    onChange={setPage}
                />
            </div>
        </MainLayout>
    );
}
